<template>
  <div>


<h2 class="goth">När</h2>

<div class="grammatikparagrafbredd leftorient">

<div class="quasi-p">
  Nedan finns några vanliga småord som svarar på frågan <b><i>wann?</i></b>  &nbsp; <i>(när?)</i>
</div>


<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i><b>jetzt</b></i></td>
        <td class="ljusgra"><i>nu</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>dann</b></i></td>
      <td class="ljusgra"><i>då</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>bald</b></i></td>
      <td class="ljusgra"><i>snart</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>sofort</b></i></td>
      <td class="ljusgra"><i>genast</i></td>
    </tr>


    <tr class="leftorient">
      <td class="ljusgra"><i><b>gleich</b></i></td>
      <td class="ljusgra"><i>strax (efter detta)</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>heute</b></i></td>
      <td class="ljusgra"><i>idag</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>morgen</b></i></td>
      <td class="ljusgra"><i>imorgon</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>gestern</b></i></td>
      <td class="ljusgra"><i>igår</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>übermorgen</b></i></td>
      <td class="ljusgra"><i>i övermorgon</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>vorgestern</b></i></td>
      <td class="ljusgra"><i>i förrgår</i></td>
    </tr>



</table>
<br><br>
<div class="quasi-p">
  Om man vill ange en mer specifik tidpunkt används ett av följande pronomen:
</div>



<h4><i>um</i></h4>
  <div class="quasi-p no-visited-link">

    om det handlar om      <router-link

         :to="'/grammatikboken/klockan'">
            klockslag
        </router-link>
  </div>
<br>

  <h4><i>am</i></h4>
    <div class="quasi-p">

      om det handlar dagar eller en del av en dag
    </div>


    <table class="">
    <br>

        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Montag</b></i></td>
            <td class="ljusgra"><i>på måndag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Dienstag</b></i></td>
            <td class="ljusgra"><i>på tisdag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Mittwoch</b></i></td>
            <td class="ljusgra"><i>på onsdag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Donnertag</b></i></td>
            <td class="ljusgra"><i>på torsdag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Freitag</b></i></td>
            <td class="ljusgra"><i>på fredag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Samstag</b></i></td>
            <td class="ljusgra"><i>på lördag</i></td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra"><i><b>am Sonntag</b></i></td>
            <td class="ljusgra"><i>på söndag</i></td>
        </tr>

      </table>

<br><br>
      <table class="">

        <tr class="leftorient">
          <td class="ljusgra"><i><b>am Morgen</b></i></td>
          <td class="ljusgra"><i>på morgonen</i></td>
        </tr>

        <tr class="leftorient">
          <td class="ljusgra"><i><b>am Vormittag</b></i></td>
          <td class="ljusgra"><i>på förmiddagen</i></td>
        </tr>

        <tr class="leftorient">
          <td class="ljusgra"><i><b>am Nachmittag</b></i></td>
          <td class="ljusgra"><i>på eftermiddagen</i></td>
        </tr>



        <tr class="leftorient">
          <td class="ljusgra"><i><b>am Abend</b></i></td>
          <td class="ljusgra"><i>på kvällen</i></td>
        </tr>



    </table>

<div class="quasi-p">
MEN
</div>
    <table class="">

      <tr class="leftorient">
        <td class="ljusgra"><i><b class="rod">in der Nacht</b></i></td>
        <td class="ljusgra"><i>på natten</i></td>
      </tr>

</table>

<br><br>

<h4><i>im</i></h4>
  <div class="quasi-p">

    om det handlar om år eller del av ett år
  </div>


  <table class="">
  <br>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Januar</b></i></td>
          <td class="ljusgra"><i>i januari</i></td>
      </tr>


      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Februar</b></i></td>
          <td class="ljusgra"><i>i februari</i></td>
      </tr>


      <tr class="leftorient">
          <td class="ljusgra"><i><b>im März</b></i></td>
          <td class="ljusgra"><i>i mars</i></td>
      </tr>


      <tr class="leftorient">
          <td class="ljusgra"><i><b>im April</b></i></td>
          <td class="ljusgra"><i>i april</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Mai</b></i></td>
          <td class="ljusgra"><i>i maj</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Juni</b></i></td>
          <td class="ljusgra"><i>i juni</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Juli</b></i></td>
          <td class="ljusgra"><i>i juli</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im August</b></i></td>
          <td class="ljusgra"><i>i augusti</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im September</b></i></td>
          <td class="ljusgra"><i>i spetember</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Oktober</b></i></td>
          <td class="ljusgra"><i>i oktober</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im November</b></i></td>
          <td class="ljusgra"><i>i november</i></td>
      </tr>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>im Dezember</b></i></td>
          <td class="ljusgra"><i>i december</i></td>
      </tr>
    </table>
<br>
<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i><b>im Winter</b></i></td>
        <td class="ljusgra"><i>på vintern</i></td>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra"><i><b>im Frühling</b></i></td>
        <td class="ljusgra"><i>på våren</i></td>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra"><i><b>im Sommer</b></i></td>
        <td class="ljusgra"><i>på sommaren</i></td>
    </tr>


    <tr class="leftorient">
        <td class="ljusgra"><i><b>im April</b></i></td>
        <td class="ljusgra"><i>i april</i></td>
    </tr>
</table>

<div class="quasi-p mindre">
  Uttrycken ovan kan också betyda <i>till vintern / i vintras </i>o.s.v.
</div>



<br><br>

<h4><i>zu</i></h4>
  <div class="quasi-p">

    om det handlar om högtider
  </div>


  <table class="">
  <br>

      <tr class="leftorient">
          <td class="ljusgra"><i><b>zu Weihnachten</b></i></td>
          <td class="ljusgra"><i>på julen</i></td>
      </tr>


      <tr class="leftorient">
          <td class="ljusgra"><i><b>zu Ostern</b></i></td>
          <td class="ljusgra"><i>i påsk</i></td>
      </tr>


</table>


</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "när als wann wenn"
            }
        ]
    }
}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
